import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Table, Button, Spinner } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";

const StaffPermissions = () => {
  const { staffId } = useParams();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [staff, setStaff] = useState(null);

  // Get JWT token from localStorage
  const getAuthToken = () => localStorage.getItem("authToken"); // Retrieve token from localStorage

  useEffect(() => {
    fetchStaff();
    fetchPermissions();
  }, []);

  const fetchStaff = async () => {
    const token = getAuthToken();
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}get-staff`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: staffId }),
      });
      const data = await response.json();
      if (response.ok) setStaff(data.data);
    } catch (error) {
      console.error("Failed to fetch staff details:", error);
    }
  };

  const fetchPermissions = async () => {
    const token = getAuthToken();
    try {
      const response = await axios.get(
        `${appConstants.API_ROOT_URL}get-staff-permissions?staff_id=${staffId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setPermissions(response.data.permissions);
    } catch (error) {
      console.error("Failed to fetch permissions", error);
    } finally {
      setLoading(false);
    }
  };

  const togglePermission = async (permissionId, assigned) => {
    const token = getAuthToken();
    try {
      const response = await axios.post(
        `${appConstants.API_ROOT_URL}update-staff-permission`,
        {
          staff_id: staffId,
          permission_id: permissionId,
          assigned: !assigned,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.data.status === "success") {
        setPermissions((prevPermissions) =>
          prevPermissions.map((perm) =>
            perm.id === permissionId ? { ...perm, assigned: !assigned } : perm
          )
        );
      } else {
        alert(response.data.message || "Failed to update permission");
      }
    } catch (error) {
      // Extract error message from server response if available
      const errorMessage =
        error.response?.data?.message || "An error occurred while updating permission.";
      alert(errorMessage);
      console.error("Failed to update permission:", error);
    }
  };
  

  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <Layout>
      <div className="container mt-4">
        <h3>Manage Permissions for '{staff?.name}'</h3>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Permission</th>
                <th>Assigned</th>
              </tr>
            </thead>
            <tbody>
              {permissions.map((perm, index) => (
                <tr key={perm.id}>
                  <td>{index + 1}</td>
                  <td>{capitalizeFirstLetter(perm.name.replace(/_/g, " "))}</td>
                  <td>
                    <Button
                      variant={perm.assigned ? "success" : "danger"}
                      size="sm"
                      onClick={() => togglePermission(perm.id, perm.assigned)}
                    >
                      {perm.assigned ? <FaCheck /> : <FaTimes />}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </Layout>
  );
};

export default StaffPermissions;
